import { render, staticRenderFns } from "./group-add-goods-pop.vue?vue&type=template&id=2176c5c8&scoped=true&"
import script from "./group-add-goods-pop.vue?vue&type=script&lang=js&"
export * from "./group-add-goods-pop.vue?vue&type=script&lang=js&"
import style0 from "./group-add-goods-pop.vue?vue&type=style&index=0&id=2176c5c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176c5c8",
  null
  
)

export default component.exports